export class AUSTreatmentTypes {
  static trainer_potential_long_acting_mdf = "trainer_potential_long_acting";
  static trainer_routine_mdf = 'trainer_routine';
  static trainer_routine_procedure_form = 'trainer_routine_procedure_form';
  static pre_travel_trainer_potential_long_acting = "pre_travel_trainer_potential_long_acting";
  static pre_travel_trainer_routine = 'pre_travel_trainer_routine';
  static pre_travel_trainer_routine_procedure_form = 'pre_travel_trainer_routine_procedure_form'
}

export class FrequencyType {
  static SingleUse = 'Single use';
  static Other = 'Other'
}

export class FormStatus {
  static Open = 'Open';
  static Inprogress = 'In Progress';
  static Submitted = 'Submitted';
  static Accepted = 'Accepted';
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/types/aus-form-types.ts